import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
    return (
        <div className="bg-black py-5 text-white">
            <Container>
                <p className="text-center text-muted">© Copyright Portfolio by Hayatul Emon 2021</p>
            </Container>
        </div>
    );
};

export default Footer;